import "../CSS/formAgregarUsuario.css";
import IncrementadorNum from "./IncrementadorNum";
import React, { useRef, useEffect, useState, Fragment } from "react";
import NavBar from "./NavBar";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import ItemUsuario from "./ItemUsuario";
import Box from "@mui/material/Box";

import TextField from "@mui/material/TextField";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import ContactMailRoundedIcon from "@mui/icons-material/ContactMailRounded";
import PasswordRoundedIcon from "@mui/icons-material/PasswordRounded";
import { db } from "../FirebaseConfig/firebase";
import { collection, addDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

const MySwal = withReactContent(Swal);
function FormAgregarUsuario() {

  const [cip, setCip] = React.useState("");
  const [estado, setEstado] = React.useState("");
  const [nivel, setNivel] = React.useState("");
  const [nombre, setNombre] = React.useState("");
  const [apellidos, setApellidos] = React.useState("");
  const [especialidad, setEspecialidad] = React.useState("");
  const [dni, setDni] = React.useState("");



  const navigate = useNavigate();
  const comunicadosList = collection(db, "USUARIOS");


  const handleChangeEst = (event) => {
    setEstado(event.target.value);
  };
  const handleChangeNiv = (event) => {
    setNivel(event.target.value);
  };
  const validarFormulario = (e) => {
    if (
		cip == "" ||
      estado == "" ||
      nivel == "" ||
      nombre == "" ||
      dni == "" ||
      apellidos == "" ||
	  especialidad == ""
    ) {
      MySwal.fire("", "Llenar todos los campos", "error");
    } else {
      store(e);
    }
  };

  const store = async (e) => {
    e.preventDefault();

    MySwal.fire({
      title: "Agregar Usuario? ",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Agregar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await addDoc(comunicadosList, {
          nombre: nombre,
		  apellidos:apellidos,
          dni: dni,
          nivel: nivel,
          estado: estado,
		  cip: cip,
          especialidad: especialidad,
        });
        Swal.fire("Agregado", "El usuario ha sido agregado", "success");
        navigate("/panelAdmin/usuarios");
      }
    });
  };
  //cerrar detalles comunicado
  const cerrar = () => {
    navigate("../panelAdmin/usuarios");
  };
  return (
    <Fragment>
      <NavBar
        titulo="Agregar Usuario"
        imagen="cerrar"
        logoTitulo="usuarios"
        cerrar={cerrar}
      ></NavBar>
      <div className="fau-agregarUsuarios">
        <div className="fau-card">
          <div className="fau-formNumber">
            <Box sx={{ width: 350 }}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <PersonRoundedIcon
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                />
                <TextField
                  sx={{ width: 350 }}
                  label="Ingrese Nombre"
                  value={nombre}
                  variant="standard"
                  onChange={(e) => setNombre(e.target.value)}
                />
              </Box>
            </Box>
          </div>
		  <div className="fau-formNumber">
            <Box sx={{ width: 350 }}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <PersonRoundedIcon
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                />
                <TextField
                  sx={{ width: 350 }}
                  label="Ingrese Apellidos"
                  value={apellidos}
                  variant="standard"
                  onChange={(e) => setApellidos(e.target.value)}
                />
              </Box>
            </Box>
          </div>
		  <div className="fau-formNumber">
            <Box sx={{ width: 350 }}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <PasswordRoundedIcon
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                />
                <TextField
                  sx={{ width: 350 }}
                  label="Ingrese DNI"
                  variant="standard"
                  type="number"
                  value={dni}
                  onChange={(e) => setDni(e.target.value)}
                />
              </Box>
            </Box>
          </div>
          <div className="fau-formNumber">
            <Box sx={{ width: 350 }}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <ContactMailRoundedIcon
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                />
                <TextField
                  sx={{ width: 350 }}
                  label="Ingrese Codigo CIP"
                  variant="standard"
                  type="number"
                  value={cip}
                  onChange={(e) => setCip(e.target.value)}
                />
              </Box>
            </Box>
          </div>

          <div className="fau-formNumber">
            <Box sx={{ width: 350 }}>
              <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <PersonRoundedIcon
                  sx={{ color: "action.active", mr: 1, my: 0.5 }}
                />
                <TextField
                  sx={{ width: 350 }}
                  label="Ingrese Especialidad"
                  value={especialidad}
                  variant="standard"
                  onChange={(e) => setEspecialidad(e.target.value)}
                />
              </Box>
            </Box>
          </div>

         
          <div className="fau-formNumber">
            <Box sx={{ width: 300 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Nivel de usuario
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={nivel}
                  label="Nivel de usuario"
                  onChange={handleChangeNiv}
                >
                  <MenuItem value={"admin"}>Administrador</MenuItem>
                  <MenuItem value={"ingeniero"}>Ingeniero</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>
          <div className="fau-formNumber">
            <Box sx={{ width: 300 }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Estado</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={estado}
                  label="Estado"
                  onChange={handleChangeEst}
                >
                  <MenuItem value={"HABILITADO"}>HABILITADO</MenuItem>
                  <MenuItem value={"NO HABILITADO"}>NO HABILITADO</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </div>
          <div className="fau-formNumber">
            <div className="fau-addUser">
              <input
                type="submit"
                value="Agregar Usuario"
                className="fau-btnAgregarComunicado"
                onClick={validarFormulario}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default FormAgregarUsuario;
